"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RectSchema = void 0;
const zod_1 = require("zod");
const DrawingBase_1 = require("./DrawingBase");
const LineStyle_1 = require("./LineStyle");
const XYPosition_1 = require("./XYPosition");
exports.RectSchema = DrawingBase_1.DrawingBaseSchema.extend({
    type: zod_1.z.literal('rect'),
    start: XYPosition_1.XYPositionSchema,
    end: XYPosition_1.XYPositionSchema,
    strokeWidth: zod_1.z.number(),
    filled: zod_1.z.coerce.boolean().optional(),
    lineStyle: LineStyle_1.LineStyleSchema.optional(),
});
//# sourceMappingURL=Rect.js.map